import { Component, Watch } from "vue-property-decorator";
import api from "@/services/api";
import baseUserContextComponent from "../baseUserContextComponent";
import { process as kendoProcess } from '@progress/kendo-data-query';
import Vue from "vue";
import { Filter, Filters } from "@/models/grid/filter";
import headerCellTemplate from "./cellTemplate/headerTemplate.vue";
import helpers from "@/helpers";
import { VNode } from "vue/types/umd";
import { operationResult } from "@/models/operationResult";
import { TextValueItem } from "@/models/TextValueItem";
import moment from "moment";
import { PartecipanteItem } from "@/models/ricercaGaranzie/partecipanteItem";

@Component({})
export default class gridComponentBase extends baseUserContextComponent {
	[x: string]: any;
	expandedField: string = "_expanded";
	customSelectedField: string = "_customSelected";
	selectedRowField: string = "_selectedRow";
	maxPageSizeValue: number = 2147483647;
	itemsGrid: any[] = [];

	//columns: any = [];
	gridData: any = [];

	//#region -- paging --
	pageable: any = {
		pageSize: 20,
		pageSizes: [20, 40, 60, 100, "tutti"],
		messages: {
			display: "{0}-{1} di {2} elementi",
			empty: "Nessun dato",
			first: "Prima",
			last: "Ultima",
			next: "Successiva",
			previous: "Precedente",
			itemsPerPage: "elementi per pagina"
		}
	};
	pageSize: number = 20;
	pageIndex: number = 0;
	take: number = 20;
	skip: number = 0;
	//#endregion

	//#region -- sort --
	sort: any = [];
	//#endregion

	//#region grouping
	headerCellGroupTemplate: string = "myHeaderCellGroupTemplate";
	group: any = [];
	groupForSort: any = [];
	expandedItems: any = [];
	groupable: any = {
		messages: {
			empty: "&nbsp;Trasporta una colonna per Raggruppare"
		}
	};
	//#endregion

	total: number = 0;
	filter: Filter = {
		filters: []
	};

	editMode: boolean = false;

	filterable: any = {
		messages: {
			info: "Filtra per:",
			and: "e",
			or: "oppure",
			filter: "Applica",
			clear: "Rimuovi"
		},
		operators: {
			isTrue: "Vero",
			isFalse: "Falso",
			selectValue: "Scegli",
			operator: "Operatore",
			value: "Valore",
			string: {
				contains: "Contiene",
				eq: "Uguale a",
				neq: "Diverso da",
				startswith: "Comincia per",
				doesnotcontain: "Non contiene",
				endswith: "Finisce per"
			},
			number: {
				eq: "Uguale a",
				neq: "Diverso da",
				gte: "Maggiore o uguale a",
				gt: "Maggiore di",
				lte: "Minore o uguale a",
				lt: "Minore di"
			},
			date: {
				gte: "Dal",
				lte: "Al"
			},
			enums: {
				eq: "Uguale a",
				neq: "Diverso da"
			}
		}
	};

	onGroupChanged(newValue: []) {
		this.groupForSort = [];
		if (newValue && newValue.length > 0 && this.columns) {
			for (let i = 0; i < newValue.length; i++) {
				let element = newValue[i] as any;
				if (element && element.field) {
					var col = this.columns.find(function(item) {
						return item.field == element.field;
					});

					if (col && col.sortBy) {
						this.groupForSort.push({ field: col.sortBy, dir: element.dir });
					} else {
						this.groupForSort.push({ field: element.field, dir: element.dir });
					}
				}
			}
		}
	}

	setDefaultPageSize(): void {
		this.pageIndex = 0;
		this.skip = 0;
	}

	pageChangeHandler(event) {
		this.skip = event.page.skip;
		this.take = event.page.take;

		this.pageSize = !isNaN(event.page.take) ? event.page.take : 10000;

		if (this.skip === 0) {
			this.pageIndex = 0;
		} else {
			this.pageIndex = this.skip / this.take;
		}

		if (this.getData) {
			this.getData();
		}
	}

	clearSortAndFilter() {
		this.sort = [];
		this.filter = {
			filters: []
		};
		this.group = [];

		this.setDefaultPageSize();

		if (this.clearSortOrFilterCustom) {
			this.clearSortOrFilterCustom();
		}

		if (this.getData) {
			this.getData();
		}
	}

	onFilterRemove(e: headerCellTemplate) {
		if (e) {
			this.filter.filters = this.filter.filters.filter(function(item) {
				return item.field !== e.field;
			});

			// this.filter.filters.splice(findFilterIndex, 1);

			if (this.getData) {
				this.setDefaultPageSize();
				this.getData();
			}
		}
	}

	onFilterApply(e: headerCellTemplate) {
		if (e) {
			var findFilterIndex = this.filter.filters.findIndex(function(item) {
				return item.field === e.field;
			});

			if (findFilterIndex >= 0) {
				this.filter.filters = this.filter.filters.filter(function(item) {
					return item.field !== e.field;
				});
			}

			if (e.filterTypeHeader == "multiselect" && e.filterItemsSelected.length > 0) {
				for (var i = 0; i < e.filterItemsSelected.length; i++) {
					var f = e.filterItemsSelected[i];
					this.filter.filters.push({
						field: e.field,
						operator: "contains",
						value: f
					});
				}
			} else if (e.filterTypeHeader == "select") {
				let filtersToAdd: Filters = null;

				if (e.filterItemSelected) {
					this.filter.filters.push({
						field: e.field,
						operator: e.filterCompareSelected,
						value: e.filterItemSelected.value
					});
				}
			} else if (e.filterTypeHeader == "numeric") {
				if (e.filterCompareSelected && e.filterText) {
					this.filter.filters.push({
						field: e.field,
						operator: e.filterCompareSelected,
						value: parseFloat(e.filterText)
					});
				}
			} else if (e.filterTypeHeader == "numeric-int") {
				if (e.filterCompareSelected && e.filterText) {
					this.filter.filters.push({
						field: e.field,
						operator: e.filterCompareSelected,
						value: parseInt(e.filterText)
					});
				}
			} else if (e.filterTypeHeader == "datetimerange" || e.filterTypeHeader == "daterange") {
				/*
			if (e.filterType == "multiselect" && e.filterItemsSelected.length > 0) {
				var filtersToAdd = {
					field: e.field,
					type: "multiselect",
					filter: {
						logic: "or",
						filters: []
					}
				};

				for (var i = 0; i < e.filterItemsSelected.length; i++) {
					var f = e.filterItemsSelected[i];
					filtersToAdd.filter.filters.push({
						field: e.field,
						operator: "contains",
						value: f
					});
				}

				this.filter.push(filtersToAdd);
			} 
			*/
				if (e.startDateHeader) {
					this.filter.filters.push({
						field: e.field,
						operator: e.filterCompareSelected,
						value: new Date(e.startDateHeader as any)
					});
				}
				if (e.endDateHeader) {
					this.filter.filters.push({
						field: e.field,
						operator: e.filterCompareValue2Selected,
						value: new Date(e.endDateHeader as any)
					});
				}
			} else if (e.filterType == "boolean") {
				if (e.filterRadioButtonSelected) {
					this.filter.filters.push({
						field: e.field,
						operator: "eq",
						value: e.filterRadioButtonSelected == "true"
					});
				}
			} else if (e.filterTypeHeader) {
				this.filter.filters.push({
					field: e.field,
					operator: e.filterCompareSelected,
					value: e.filterText
				});
			} else {
				this.onFilterRemove(e);
			}

			this.$emit("grid-header-filter", this.filter);
		}
		if (this.getData) {
			this.setDefaultPageSize();
			this.getData();
		}
	}

	onFilterMobileApply() {
		if (this.getData) {
			this.setDefaultPageSize();
			this.getData();
		}
	}

	sortChangeHandler(e: any) {}

	dataStateChange(e) {
		//this.group = e.groups;
		this.createAppState(e.data);
	}

	createAppState(dataState) {
		this.group = dataState.group;
		this.take = dataState.take;
		this.skip = dataState.skip;
		if (dataState.group) {
			dataState.group.map(group => (group.aggregates = this.aggregates));
		}
		this.group = dataState.group;

		this.onGroupChanged(this.group);
		this.getData();
	}
	clickHandler(dataItem) {
		Vue.set(dataItem, this.expandedField, dataItem[this.expandedField] === undefined ? false : !dataItem[this.expandedField]);
	}
	expandChange(dataItem) {
		Vue.set(dataItem, this.expandedField, dataItem[this.expandedField] === undefined ? true : !dataItem[this.expandedField]);
	}
	customSelectionChange(dataItem) {
		Vue.set(dataItem, this.customSelectedField, dataItem[this.customSelectedField] === undefined ? true : !dataItem[this.customSelectedField]);
	}

	//#region ** Get Grid Data
	getGridData(endpoint: string) {
		var self = this;

		api.getDatiGriglia(endpoint, this.filter, this.sort, this.pageIndex, this.pageSize, this.groupForSort)
			.then(res => {
				self.itemsGrid = res.items;
				self.gridData = kendoProcess(res.items, { take: self.take, skip: 0, group: self.group });
				self.total = res.totalCount;

				// let existsAllPageSizeOption = self.pageable.pageSizes.find(function(item) {
				// 	return item > 100;
				// });

				// if (existsAllPageSizeOption) {
				// 	self.pageable.pageSizes.pop();
				// }

				// if (self.total > 100) self.pageable.pageSizes.push(self.total);
			})
			.catch(err => {
				console.log(err);
			});
	}
	getGridDataFullTextSearch(endpoint: string, fullTextSearch: string) {
		var self = this;

		api.getDatiGrigliaFullText(endpoint, this.filter, this.sort, this.pageIndex, this.pageSize, this.groupForSort, fullTextSearch)
			.then(res => {
				self.itemsGrid = res.items;
				self.gridData = kendoProcess(res.items, { take: self.take, skip: 0, group: self.group });
				self.total = res.totalCount;

				// let existsAllPageSizeOption = self.pageable.pageSizes.find(function(item) {
				// 	return item > 100;
				// });

				// if (existsAllPageSizeOption) {
				// 	self.pageable.pageSizes.pop();
				// }

				// if (self.total > 100) self.pageable.pageSizes.push(self.total);
			})
			.catch(err => {
				console.log(err);
			});
	}
	//#endregion
	//#region ** Delete Grid Item
	deleteGridRow(endpoint: string, itemID: number | string, title: string, message: string | VNode[]) {
		var self = this;
		self.$bvModal
			.msgBoxConfirm(message, {
				title: title,
				okVariant: "warning",
				okTitle: self.$i18n
					.t("btn.si")
					.toString()
					.toUpperCase(),
				cancelTitle: self.$i18n
					.t("btn.no")
					.toString()
					.toUpperCase(),
				cancelVariant: "outline-theme",
				footerClass: "",
				headerBgVariant: "warning"
				// centered: true
			})
			.then(value => {
				if (value) {
					api.deleteRowGriglia(endpoint, itemID)
						.then(res => {
							self.$bvToast.toast(self.$i18n.t("msg.cancellazioneriuscita").toString(), {
								variant: "success",
								title: self.$i18n.t("msg.cancellazioneok").toString(),
								solid: true
							});

							self.getData();
						})
						.catch(err => {
							console.log(err);
						});
				}
			})
			.catch(err => {
				// An error occurred
			});
	}
	//#endregion

	//#region ** Edit Grid Item
	setGridRow<T>(endpoint: string, item: T, title: string | VNode | VNode[], message: string | VNode | VNode[]): Promise<operationResult<T>> {
		var self = this;
		return new Promise(function(resolve, reject) {
			api.setGridRow<T>(endpoint, item)
				.then(res => {
					self.$bvToast.toast(message, {
						variant: "success",
						title: title,
						solid: true
					});

					self.getData();
					//self.showEditModal = false;
					resolve(res);
				})
				.catch(err => {
					console.log(err);
					reject(err);
				});
		});
	}
	//#endregion

	//#region ** Get Property columns for Custom template **
	getColumsnDefinition(field: string): any {
		if (this.columns) {
			var c = this.columns.find(function(f) {
				return f.field == field;
			});
			return c || {};
		}
		return {};
	}

	getColumnType(field: string): string {
		var c = this.getColumsnDefinition(field);
		return c.type || "string";
	}

	getPathFallback(field: string): string {
		var c = this.getColumsnDefinition(field);
		return c.pathFallback || "";
	}

	idDisabledCell(field: string): boolean {
		var c = this.getColumsnDefinition(field);
		return c.disabled || false;
	}

	isColumnFilterable(field: string): boolean {
		var c = this.getColumsnDefinition(field);
		return c.filterable || false;
	}

	onSortChanged(e: any) {
		var field = e.sortBy || e.field;
		if (this.sort && this.sort.length > 0) {
			var existFieldSorted = this.sort.find(function(f) {
				return f.field == field;
			});
			if (existFieldSorted) {
				if (existFieldSorted.dir == "asc") {
					existFieldSorted.dir = "desc";
				} else if (existFieldSorted.dir == "desc") {
					var findIndexOfField = this.sort.findIndex(function(f) {
						return f.field == field;
					});
					this.sort.splice(findIndexOfField, 1);
				}
			} else {
				this.sort.push({ field: field, dir: "asc" });
			}
		} else {
			this.sort = [{ field: field, dir: "asc" }];
		}

		if (this.getData) {
			this.getData();
		}
	}

	onHeaderSwitchChange(newValue) {
		if (this.gridData && this.gridData.data) {
			for (var i = 0; i < this.gridData.data.length; i++) {
				let dataItem = this.gridData.data[i];
				Vue.set(dataItem, "_ck_select", newValue);
			}
		}
	}

	//#endregion

	//#region EXPORT

	exportGridExcel(endpoint: string, data: any = null, fileName?: string, sheetTitle?: string) {
		//prima request a api e poi esport
		var columnsToExport = this.columns.filter(function(item) {
			return item.export == true;
		});

		if (columnsToExport && columnsToExport.length > 0) {
			var self = this;
			if (data) {
				self.exportExcelCreate(data, fileName, sheetTitle);
			} else {
				api.getDatiGriglia(endpoint, this.filter, this.sort, 0, 999999999, this.groupForSort)
					.then(res => {
						self.exportExcelCreate(res.items, fileName, sheetTitle);
					})
					.catch(err => {
						console.log(err);
						this.$bvToast.toast(this.$i18n.t("msg.exporterror").toString(), {
							variant: "danger",
							title: this.$i18n.t("generico.errore").toString(),
							solid: true
						});
					});
			}
		} else {
			this.$bvToast.toast(this.$i18n.t("msg.exportcolumnserror").toString(), {
				variant: "danger",
				title: this.$i18n.t("generico.configurationerror").toString(),
				solid: true
			});
		}
	}

	exportGridExcelCustomColumns(endpoint: string, data: any = null, fileName?: string, sheetTitle?: string, customColumns?: any) {
		//prima request a api e poi esport
		var columnsToExport = customColumns;

		if (columnsToExport && columnsToExport.length > 0) {
			var self = this;
			if (data) {
				self.exportExcelCreate(data, fileName, sheetTitle, customColumns);
			} else {
				api.getDatiGriglia(endpoint, "", "", 0, 999999999, "")
					.then(res => {
						self.exportExcelCreate(res.items, fileName, sheetTitle, customColumns);
					})
					.catch(err => {
						console.log(err);
						this.$bvToast.toast(this.$i18n.t("msg.exporterror").toString(), {
							variant: "danger",
							title: this.$i18n.t("generico.errore").toString(),
							solid: true
						});
					});
			}
		} else {
			this.$bvToast.toast(this.$i18n.t("msg.exportcolumnserror").toString(), {
				variant: "danger",
				title: this.$i18n.t("generico.configurationerror").toString(),
				solid: true
			});
		}
	}

	exportExcelCreate(dataItems: [], fileName?: string, sheetTitle?: string, customColumns?: any) {
		var self = this;
		let groupForSort = customColumns ? null : self.groupForSort;
		let data: any = dataItems;

		var columnsToExport = customColumns ? customColumns.filter(function(item) {
			return item.export == true;
		}) : this.columns.filter(function(item) {
			return item.export == true;
		});

		var cols = helpers.cloneObject(columnsToExport);
		cols.forEach(item => (item.hidden = false));

		if (!data || data.length <= 0) {
			this.$bvToast.toast(this.$i18n.t("export.nodataexport").toString(), {
				variant: "warning",
				title: this.$i18n.t("generico.warning").toString(),
				solid: true
			});
			return;
		}

		//righe del file da produrre
		let rows = [];

		//colonne del file da produrre
		let columnCells = {
			cells: []
		};
		let colsWidth = [];
		let colName = {};
		var hyperlinks = [];

		//Se esistono colonne da raggruppare, gestisco le stesse aggiungendole all'header del file
		//nel frattempo recupero anche i titoli che serviranno per le righe dedicate al raggruppamento
		if (groupForSort && groupForSort.length > 0) {
			for (var g = 0; g < groupForSort.length; g++) {
				let gfField = groupForSort[g].field;
				columnCells.cells.push({
					value: "",
					background: "#7A7A7A",
					color: "#fff"
				});

				colsWidth.push({ width: 20 });

				let ccO = cols.find(function(item) {
					return item.field == gfField;
				});
				colName[gfField] = ccO ? ccO.title : gfField;
			}
		}

		//Inserimento riga di HEADER
		for (var i = 0; i < cols.length; i++) {
			let col = cols[i];
			columnCells.cells.push({
				value: col.title,
				background: "#7A7A7A",
				color: "#fff"
			});

			if( col.exportWidth )
				colsWidth.push({ width: col.exportWidth});
			else
				colsWidth.push({ autoWidth: true });
		}
		rows.push(columnCells);

		var totaliPerColonna = {},
			esportaTotali = false;

		if (groupForSort && groupForSort.length > 0) {
			//caso del group by
			let groupFields: string[] = groupForSort.map(function(item) {
				return item.field;
			});
			let groupFieldCount: number = groupFields.length;
			let gValue = {};

			//Inserimentod delle prima/e righe di raggruppamento
			for (var g = 0; g < groupFieldCount; g++) {
				let row = {
					cells: []
				};
				var gf = groupFields[g];

				var dataGroup = data[0][gf] || self.$i18n.t("gridvalue.nondefinito").toString();
				if (g > 0) {
					for (var x = 0; x < g; x++) {
						row.cells.push({
							value: "",
							background: "#d9d9d9"
						});
					}
				}

				row.cells.push({
					value: `${colName[gf]}: ${dataGroup}`,
					colSpan: cols.length + groupFieldCount - g,
					background: "#d9d9d9"
				});

				gValue[`${gf}`] = dataGroup;

				rows.push(row);
			}

			for (var i = 0; i < data.length; i++) {
				let row = {
					cells: []
				};
				var ccsd = [];

				//Valutazione del raggruppamento; cioè se cambia il valore raggruppato, vado a mettere una riga di raggruppamento
				for (var g = 0; g < groupFieldCount; g++) {
					ccsd.push({
						value: "",
						background: "#d9d9d9"
					});

					let gc = groupFields[g];
					let d = data[i][gc];

					if (gValue[gc] != (d || self.$i18n.t("gridvalue.nondefinito").toString())) {
						gValue[gc] = d;
						let gIndexInside = groupFields.indexOf(gc);

						if (gIndexInside > 0) {
							for (var x = 0; x < gIndexInside; x++) {
								row.cells.push({
									value: "",
									background: "#d9d9d9"
								});
							}
						}

						row.cells.push({
							value: `${colName[gc]}: ${d}`,
							colSpan: cols.length + groupFieldCount - gIndexInside,
							background: "#d9d9d9"
						});

						rows.push(row);

						row = {
							cells: []
						};
					}
				}

				//Gestione delle righe dei dati
				for (var j = 0; j < cols.length; j++) {
					let col = cols[j];
					let d = data[i][col.field];

					if (col.field) {
						let d = data[i][col.field];
						var colPadre = columnsToExport.find( x => x.field === col.field );
						if( colPadre && colPadre.exportRenderFunction)
							d = colPadre.exportRenderFunction(d, data[i]);
						ccsd.push({
							value: d
						});
					}
				}

				row.cells = ccsd;
				rows.push(row);
			}
		} else {
			var excelRow = 2; // 1 = header, quindi i dati partono dalla riga 2
			for (var i = 0; i < data.length; i++) {
				var row = {
					cells: []
				};
				for (var j = 0; j < cols.length; j++) {
					let col = cols[j];
					if (col.field) {
						let d = data[i][col.field];
						var colPadre = columnsToExport.find( x => x.field === col.field );

						
						if( colPadre && colPadre.exportTotale ){
							esportaTotali = true;
							if( totaliPerColonna[col.field] == null )
								totaliPerColonna[col.field] = 0;
							var valTot = d;
							if( colPadre.exportValueFunction )
								valTot = colPadre.exportValueFunction(d, data[i]);
							totaliPerColonna[col.field] += valTot;
						}

						if( colPadre && colPadre.exportValueFunction)
							d = colPadre.exportValueFunction(d, data[i]);

						if( colPadre && colPadre.exportRenderFunction)
							d = colPadre.exportRenderFunction(d, data[i]);

						
						row.cells.push({
							value: d
						});
						
						if( colPadre && colPadre.exportLink){
							// const columnLetter = String.fromCharCode(65 + j); // A,B,C,D...
                			// const cellRef = `${columnLetter}${excelRow}`;
							// hyperlinks.push({
							// 	ref: cellRef,
							// 	target: d
							// });
							row.cells[row.cells.length-1] =
							{
								formula: `=HYPERLINK("${d}","Apri Certificato")`,
								color: "#0563C1",      // blu tipico dei link Excel
								underline: true
							}
							
						}
					}
				}
				rows.push(row);
    			excelRow++;
			}
		}

		if( esportaTotali ){
			var rowTot = {
					cells: []
				};
			for (var j = 0; j < cols.length; j++) {
				if( j == 0 ){
					rowTot.cells.push({ value: "Totale", background: "#7A7A7A", color: "#fff"});
				}
				else {
					var textTot = ""
					let col = cols[j];
					if (col.field && totaliPerColonna[col.field] != null) {
						textTot = totaliPerColonna[col.field];
						var colPadre = columnsToExport.find( x => x.field === col.field );
						if( colPadre && colPadre.exportRenderFunction)
							textTot = colPadre.exportRenderFunction(textTot, null);
					}
					rowTot.cells.push({ value: textTot, background: "#7A7A7A", color: "#fff"});
				}
			}
			rows.push(rowTot);
		}

		let workbook = new kendo.ooxml.Workbook({
			sheets: [
				{
					columns: colsWidth,
					// The title of the sheet.
					title: sheetTitle || "Foglio 1",
					// The rows of the sheet.
					rows: rows,
				}
			]
		});

		kendo.saveAs({ dataURI: workbook.toDataURL(), fileName: fileName || "Export.xlsx" });
	}

	exportRenderDate(date){
		if(!date)
			return "";
		var m = moment(date);
		return m ? m.format("DD/MM/YYYY") : "";
	}

	exportRenderYear(date){
		if(!date)
			return "";
		var m = moment(date);
		return m ? m.format("YYYY") : "";
	}

	exportRenderPartecipanti(data: string) {
		var array = JSON.parse(data) as PartecipanteItem[];
		let innerHtml = data;
		if (array && array.length > 0) {
			innerHtml = array
				.map(function(item) {
					return `${item.Cognome} ${item.Nome} `;
				})
				.join(", ");
		}
		return innerHtml;
	}

	// exportRenderCellImportoViaggio(data: number, dataItem: any) {
	// 	if( dataItem && dataItem.secondoImporto && dataItem.secondoImporto > 0)
	// 		return kendo.toString(dataItem.secondoImporto, "c")
	// 	return kendo.toString(data || 0, "c");
	// }

	exportValueCellImportoViaggio(data: number, dataItem: any) { // ritorna il valore per questa cella
		if(dataItem && dataItem.secondoImporto && dataItem.secondoImporto > 0)
			return dataItem.secondoImporto
		return data || 0;
	}

	exportRenderCellValuta (data: number) {
		return kendo.toString(data || 0, "c");
	}

	exportRenderLinkCertificato (data: string) {
		return `${process.env.VUE_APP_BASE_URL}/file/adesione/${data}`
	}

	exportValueCellSaldoAdesione	(data: number, dataItem: any) { // ritorna il valore per questa cella
		if(dataItem){
			data = (dataItem.totalePremioDaPagare || 0 ) - (dataItem.importoPagato || 0) - (dataItem.importoSconto || 0) ;
		}
		return data || 0;
	}

	renderFunctionNoTimeZoneDate(date){
		if(!date)
			return "";
		var m = moment(date);
		return m ? m.format("DD/MM/YYYY") : "";
	}
	

	//#endregion

	// get items() {
	// 	let items = kendoProcess(this.gridData, { take: this.take, skip: 0, group: this.group });
	// 	return items;
	// 	//return this.gridData;
	// }
}
